import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-setting"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.5 18C21.5 19.6569 20.1569 21 18.5 21C16.8431 21 15.5 19.6569 15.5 18C15.5 16.3431 16.8431 15 18.5 15C20.1569 15 21.5 16.3431 21.5 18Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 15H8C5.23858 15 3 17.2386 3 20V21H11.05M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.4999 15V13.75M18.4999 15C16.8431 15 15.4999 16.3431 15.4999 18C15.4999 19.6569 16.8431 21 18.4999 21M18.4999 15C20.1568 15 21.4999 16.3431 21.4999 18C21.4999 19.6569 20.1568 21 18.4999 21M18.4999 21V22.25M15.9019 16.5L14.8193 15.875M21.098 19.5L22.1806 20.125M21.098 16.5L22.1806 15.875M15.9019 19.5L14.8193 20.125","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserSetting = Vue.extend<IconProps>({
  name: 'UserSettingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'user-setting',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UserSetting;
